<template>
  <b-container class="auth-layout">
    <b-row>
      <b-col lg="6">
        <slot></slot>
      </b-col>
      <b-col lg="6">
        <div class="auth-layout-image">
          <img src="@/assets/images/logo-black.png" />
          <h2>راهکاری جامع در فناوری اطلاعات</h2>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions } from "vuex";
import { HIDE_MESSAGE } from "@/store/mutation-types";

export default {
  name: "Authentication",
  props: {
    title: String
  },
  mounted() {
    this[HIDE_MESSAGE]([]);
  },
  methods: {
    ...mapActions("auth", [HIDE_MESSAGE])
  }
};
</script>

<style lang="scss">
.auth-layout {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  user-select: none;

  & .row {
    background-color: #fff;
    box-shadow: 3px 3px 15px 0px #858585;
    border-radius: 5px;
    padding: 60px 0;
  }

  &-form {
    max-width: 600px;
    margin: 0 auto;
    @media (min-width: 1200px) {
      padding: 0 80px;
    }
    @media (max-width: 1200px) {
      padding: 0 50px;
    }
    @media (max-width: 768px) {
      padding: 0 10px;
    }
  }
  & &-title {
    text-align: center;
    margin-bottom: 20px;
  }
  & &-footer {
    display: flex;
    justify-content: space-between;
  }
  & &-image {
    padding: 0 50px;
    width: 100%;
    height: 100%;
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media (min-width: 992px) {
      display: flex;
    }

    img {
      width: 100%;
      margin-bottom: 10px;
    }
  }
}
</style>
